import { render, staticRenderFns } from "./ParceiroContaEscrow.vue?vue&type=template&id=2fe602a9&"
import script from "./ParceiroContaEscrow.vue?vue&type=script&lang=js&"
export * from "./ParceiroContaEscrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports